import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Button,
  Image,
  List,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Segment,
} from 'semantic-ui-react';

function NpwpReviewDetailsModal({ open, onClose, onConfirm, isLoading }) {
  const npwp = useSelector(state => state.npwp.businessDetail.npwp);

  const onModalClosing = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onModalClosing}>
      <ModalHeader>Review Details</ModalHeader>
      <ModalContent>
        <Segment>
          <h3>NPWP</h3>
          {!!npwp && (
            <List>
              <List.Item>
                <strong>Name:</strong> {npwp.name}
              </List.Item>
              <List.Item>
                <strong>NPWP Number:</strong> {npwp.number}
              </List.Item>
              <List.Item>
                <strong>NPWP Photo:</strong>
                <br />
                <Image src={npwp.image} size="large" />
              </List.Item>
            </List>
          )}
        </Segment>
      </ModalContent>
      <ModalActions>
        <Button onClick={onModalClosing} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          primary
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          Confirm Detail
        </Button>
      </ModalActions>
    </Modal>
  );
}

NpwpReviewDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default NpwpReviewDetailsModal;
